var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { key: "sign-up", staticClass: "t-onboard__body" }, [
    _c("div", { staticClass: "t-onboard__main t-onboard__main--flex" }, [
      _c(
        "div",
        { staticClass: "t-onboard__left t-onboard__left--signupTestimonial" },
        [
          _c("div", { staticClass: "t-onboard__content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "t-onboard__title" }, [
              _vm._v(_vm._s(_vm.$t("onboard.register.title"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "t-onboard__form t-mar--t-md" },
              [
                _c("t-input", {
                  attrs: {
                    fluid: "",
                    placeholder: _vm.$t("onboard.register.email_sign_up.email"),
                    invalid: _vm.invalidEmail,
                    autofocus: true,
                    type: "email",
                    size: "large",
                    talign: "center",
                    "invalid-message": _vm.errorMessage,
                  },
                  on: {
                    keyup: [
                      _vm.keyup,
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.next()
                      },
                    ],
                  },
                  model: {
                    value: _vm.email,
                    callback: function ($$v) {
                      _vm.email = $$v
                    },
                    expression: "email",
                  },
                }),
                _vm._v(" "),
                _c(
                  "t-checkbox",
                  {
                    staticClass: "t-mar--t-sm t-flex",
                    attrs: { checked: _vm.isAgreed, size: "small" },
                    on: { update: _vm.updateAgreement },
                  },
                  [
                    _c("span", { staticClass: "t-onboard__description" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("onboard.register.description.agree")) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "t-td--border",
                          attrs: {
                            href: "https://trainn.co/terms/",
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("onboard.register.description.terms")
                              )
                          ),
                        ]
                      ),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("onboard.register.description.and")) +
                          " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "t-td--border",
                          attrs: {
                            href: "https://trainn.co/privacy/",
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("onboard.register.description.privacy")
                            )
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.agreementError
                  ? _c(
                      "p",
                      {
                        staticClass:
                          "t-input__error t-mar--t-no t-mar--b-no t-pad--t-ti t-ta--left",
                      },
                      [_vm._v(_vm._s(_vm.agreementError))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "t-button",
                  {
                    staticClass: "t-mar--t-sm",
                    attrs: {
                      fluid: "",
                      loading: _vm.genericLoader,
                      size: "large",
                      variant: "primary",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.next()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.nextStepCTA) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "t-mar--t-lg t-onboard__caption" },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("onboard.register.existing_user.text"))),
                ]),
                _vm._v(" "),
                _c("router-link", { attrs: { to: "/login" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("onboard.register.existing_user.link")) +
                      "\n          "
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isReferral
              ? _c(
                  "div",
                  { staticClass: "t-signupTestimonial__logos t-mar--t-lg" },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/lib/assets/images/companies/facilio.png"),
                        height: "21",
                      },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/lib/assets/images/companies/spotdraft.png"),
                        height: "26",
                      },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/lib/assets/images/companies/coherent.png"),
                        height: "28",
                      },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/lib/assets/images/companies/buildops.png"),
                        height: "24",
                      },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("@/lib/assets/images/companies/posist.png"),
                        height: "20",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "t-onboard__right t-onboard__right--signupTestimonial" },
        [
          _vm.isReferral
            ? _c("div", { staticClass: "t-onboard__referral" }, [
                _c("img", {
                  attrs: {
                    src: require("@/lib/assets/images/signup/referral_signup.png"),
                  },
                }),
                _vm._v(" "),
                _c("h2", [
                  _vm._v("You’ve been invited by a friend to try Trainn"),
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(
                    "Enjoy 20% discount on any Trainn plan for the first six months, thanks to your friend."
                  ),
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("img", {
                  staticClass: "t-signupTestimonial__arrowIcon referral",
                  attrs: { src: require("@/lib/assets/images/arrow.png") },
                }),
              ])
            : _c("signup-testimonial"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "t-onboard__logo",
        attrs: { href: "https://trainn.co/", target: "_blank" },
      },
      [
        _c("img", {
          attrs: {
            src: require("@/lib/assets/images/Trainn-Type-Assets/Trainn-type-original.png"),
            height: "24px",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v(
        "\n          Sign up to explore our all-in-one Customer Education Platform to transform your product training experiences. \n          Or               \n          "
      ),
      _c(
        "a",
        { attrs: { href: "mailto:support@trainn.co", target: "_blank" } },
        [_vm._v(" contact support")]
      ),
      _vm._v(".\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }